export default {"src":"/_next/static/media/seedling_color.ce80947f.svg","height":32,"width":32};